
import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import usuarioService from '../../../service/seguridad/usuarioService';

import Header from './Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import ViewModal from './ViewModal';
import ImprimirModal from './ImprimirModal';
import auth from '../../../common/utility/auth';

import CierreModal from '../GestionCaja/CerrarCaja/CierreModal';

import vendedorService from '../../../service/administracion/vendedorService';
import AnexoModal from '../ArqueoCaja/AnexoModal';

import printFormatMock from "../../../common/mock/printFormatMock";
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';

import establecimientoService from '../../../service/administracion/establecimientoService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import cajaService from '../../../service/administracion/cajaService';
import cajaAperturaService from '../../../service/tesoreria/cajaAperturaService';
import arqueoCajaService from '../../../service/tesoreria/arqueoCajaService';
import { TESORERIA } from '../../../common/types/moduloType';
import { VER_CAJA_COB, APER_CAJA_COB } from '../../../common/types/configuracionType';


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {

            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingImprimir: false,
            loadingPrint: false,
            loadingVer: false,
            loadingChange: true,
            viewVisible: false,
            imprimirVisible: false,
            viewAnexo: false,
            viewCierreVisible: false,
            listaEmpleado: [],
            listaCaja: [],
            listaEstado: [],
            listaEstablecimiento: [],
            tiposCambioDiario: [],
            listaEfectivoSoles: [],
            listaEfectivoDolares: [],
            listaResumen: [],
            permisosUsuario: [],
            idEmpleado: 0,
            serie_correlativo: {
                nroSerie: '',
                correlativo: ''
            },
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                formatos: printFormatMock.values,
                response: undefined,
            },

            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idEstablecimiento: 0,
                idCaja: 0,
                idEmpleado: 0,
                idEstado: 0,
                nroPlanilla: '',
                cajas: [],
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()

        }
    }


    fetchEmptyFormValues = () => {
        return {
            id: 0,
            serie: "",
            correlativo: "",
            FechaTipoCambio: global.fetchCurrentDateStr(),
            fechaReferencial: global.fetchCurrentDateStr(),
            TipoCambio: 0,
            idEstablecimiento: 0,
            idCaja: 0,
            idResponsable: 0,
            responsable: '',
            usuario: '',
            saldoSoles: 0,
            saldoDolares: 0,
            listaEmpleado: [],
            listaCaja: [],
            listaEstablecimiento: [],
            listaEfectivoSoles: [],
            listaEfectivoDolares: [],
            listaResumen: []
        }
    };


    //#region FILTER

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value, name, valor) => {

        const filter = { ...this.state.filter, [property]: value };
        if (property === 'idEstablecimiento') {
            filter.cajas = this.state.listaCaja.filter(m => m.iD_Establecimiento === value && m.idTipoCaja == 1);
            filter.idCaja = 0;
        }

        if (name !== undefined) {

            switch (name) {
                case 'establecimiento':
                    filter.establecimiento = valor;
                    break;
                case 'caja':
                    filter.caja = valor;
                    break;
                case 'empleado':
                    filter.empleado = valor;
                    break;
                case 'estado':
                    filter.estado = valor;
                    break;
            }
        }

        this.setState({ filter });


    };

    handleClearFilters = () => {
        var filter = {

            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idEstablecimiento: 0,
            idCaja: 0,
            idEmpleado: this.state.filter.idEmpleado,
            idEstado: 0,
            nroPlanilla: '',
            cajas: [],
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };


    handleFilter = (item) => {
        if (item !== undefined) {
            var formValues = this.fetchEmptyFormValues();
            formValues.listaEstablecimiento = this.state.listaEstablecimiento ? this.state.listaEstablecimiento : [];
            formValues.TipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.listaCaja = this.state.listaCaja ? this.state.listaCaja : [];
            formValues.usuario = item[0].nombre;
            formValues.idResponsable = item[0].id;

            formValues.serie = this.state.serie_correlativo.nroSerie;

            formValues.correlativo = this.state.serie_correlativo.correlativo;

            this.setState({ visible: true, formValues });


        }



    };


    //#endregion END  FILTER

    //#region RESULT-LIST

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await cajaAperturaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Caja Apertura.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await cajaAperturaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Caja Apertura.pdf");
    }

    handleImprimir = async (item) => {

        this.setState({ loadingImprimir: true });
        var file = undefined;
        var response = undefined;
        var idFormato = 1; //pdf

        if (item.saldoCierreDolares == 0 && item.saldoCierreSoles == 0) {
            dialog.error('El monto de caja cierre es 0');
            this.setState({ loadingImprimir: false });

            return false;
        }

        if (idFormato === 1) {
            response = await cajaAperturaService.pdfPrint(item.id);
            file = window.URL.createObjectURL(response.data);
        }



        this.setState({
            loadingImprimir: false,
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                idComprobante: item.id,
                file
            },
            selectedItem: item
        });
    };


    handleChangeImprimir = async (idFormato) => {
        debugger
        var file = undefined;
        var response = undefined;
        var id = this.state.imprimirFormValues.idComprobante;
        if (idFormato === 1) {
            response = await cajaAperturaService.pdfPrint(id);
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cajaAperturaService.pdfTicket(id);
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
            },
        });
    };




    handleChangeAutocomplete = (value) => {
        debugger
        this.setState({
            filter: {
                ...this.state.formValues,
                idResponsable: value.key
            }
        });
    };
    handleClearAutocomplete = () => {
        this.setState({
            filter: {
                ...this.state.filter,
                idResponsable: 0
            }
        });
    }


    //#endregion END  RESULT-LIST



    //#region REGISTRO NUEVO
    handleNew = async () => {
        var flagNew = this.state.configuraciones.filter((m) => m.abreviatura === APER_CAJA_COB).length >= 1 ? true : false;

        if (!flagNew) {
            dialog.error('El Usuario ' + auth.user().nombre + ' no tiene para aperturar caja de cobranza');
            return false;
        }

        var usuarioId = auth.user().id;
        var usuario = auth.user().nombre + ' ' + auth.user().apellidoMaterno + ' ' + auth.user().apellidoPaterno;

        const seriecorrelativo = await cajaAperturaService.Getcorrelativo();
        var formValues = this.fetchEmptyFormValues();
        //formValues.listaEstablecimiento = this.state.listaEstablecimiento ? this.state.listaEstablecimiento : [];
        formValues.listaEstablecimiento = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.listaEstablecimiento;

        formValues.TipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listaCaja = this.state.listaCaja ? this.state.listaCaja : [];
        formValues.idResponsable = usuarioId;

        formValues.listaEmpleado = [{ 'id': usuarioId, 'nombre': usuario }];

        formValues.serie = seriecorrelativo.nroSerie;

        formValues.correlativo = seriecorrelativo.correlativo;

        this.setState({ visible: true, formValues });


    };


    handleEstablecimiento = () => {
        var newEstablecimiento = new Array();

        if (this.state.permisosUsuario.length == 0) {
            return newEstablecimiento;
        } else {
            //return establecimiento group by
            const Oreturn = this.handleGroupBy(this.state.permisosUsuario);

            Oreturn.forEach(element => {
                var obj = this.state.listaEstablecimiento.filter(m => m.id == element);
                if (obj.length > 0) {
                    var item = {
                        codigoSunat: obj[0].codigoSunat,
                        direccion: obj[0].direccion,
                        id: obj[0].id,
                        idDepartamento: obj[0].idDepartamento,
                        idProvincia: obj[0].idProvincia,
                        idTipoEstablecimiento: obj[0].idTipoEstablecimiento,
                        idUbigeo: obj[0].idUbigeo,
                        nombre: obj[0].nombre,
                        nombreTipoEstablecimiento: obj[0].nombreTipoEstablecimiento
                    }
                    newEstablecimiento.push(item);

                }
            });

        }
        return newEstablecimiento;
    }

    handleGroupBy(array) {
        var lista = new Array();
        array.forEach(element => {
            lista.push(element.idEstablecimiento);
        });

        return lista.filter((item, index) => lista.indexOf(item) === index);
    }


    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    };




    handleChangeEstablecimiento = (values, form) => {
        const filter = this.state.listaCaja.filter(m => m.iD_Establecimiento === values && m.idTipoCaja == 1);
        if (filter.length == 0)
            message.info("no se encuentra la caja registrada! ");

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaCaja: filter,
                idCaja: filter.length > 0 ? filter[0].id : 0
            },
            loadingChange: false,
        });

    };



    handleSave = async (values, form) => {

        dialog.confirm(values.id === 0 ? "¿Desea apertura la caja " + values.serie + "-" + values.correlativo + "?" : "¿Esta seguro de realizar la acción?", async () => {
            var response;


            if (values.id === 0)
                response = await cajaAperturaService.registrar(values);

            else
                response = await cajaAperturaService.modificar(values);

            if (response.status === 200) {

                form.resetFields();

                this.setState({
                    visible: false,

                });

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleEdit = async (item) => {

        var response = await cajaAperturaService.obtenerPorId(item.id);

        var usuarioId = auth.user().id;
        var usuario = auth.user().nombre + ' ' + auth.user().apellidoMaterno + ' ' + auth.user().apellidoPaterno;


        if (response !== undefined) {


            var formValues = this.fetchEmptyFormValues();
            formValues.listaEstablecimiento = this.state.listaEstablecimiento ? this.state.listaEstablecimiento : [];
            formValues.TipoCambio = response.tipoCambio;
            formValues.FechaTipoCambio = response.fecha;
            formValues.listaCaja = this.state.listaCaja ? this.state.listaCaja : [];
            formValues.fechaReferencial = response.fechaReferencial;

            formValues.serie = response.nroSerie;
            formValues.idEstablecimiento = response.iD_Establecimiento;
            formValues.idCaja = response.iD_Caja;
            //formValues.responsable=response.nroEmpleado;
            //formValues.usuario=response.empleado;
            formValues.idResponsable = usuarioId;

            formValues.listaEmpleado = [{ 'id': usuarioId, 'nombre': usuario }];

            formValues.id = item.id;

            formValues.saldoSoles = response.saldoInicialSoles;
            formValues.saldoDolares = response.saldoInicialDolares;


            formValues.correlativo = response.correlativo;

            this.setState({ visible: true, formValues });


        }
    }


    handleCerrarCaja = (values, form) => {

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            var FilterValues = values.filter(value => value.cantidad > 0);

            debugger
            if (FilterValues.length == 0) {
                var detalleProductos = {
                    id_CajaApertura: this.state.formValues.id,
                    abreviatura: "S/",
                    cantidad: 0,
                    formato: "Moneda",
                    id: 0,
                    id_Moneda: 0,
                    monto: 0,
                    total: 0
                };
                FilterValues.push(detalleProductos);
            }
            response = await cajaAperturaService.registrarCaja_Cierre(FilterValues);


            if (response.status === 200) {
                form.resetFields();
                this.setState({
                    viewCierreVisible: false,
                });
                message.success(('Registrado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    //#endregion END  REGISTRO NUEVO

    //#region VIEW


    handleView = async (item) => {
        debugger

        console.log(item);
        var response = await cajaAperturaService.obtenerPorId(item.id);



        if (response !== undefined) {


            var formValues = this.fetchEmptyFormValues();
            formValues.listaEstablecimiento = this.state.listaEstablecimiento ? this.state.listaEstablecimiento : [];
            formValues.TipoCambio = response.tipoCambio;
            formValues.FechaTipoCambio = response.fecha;
            formValues.listaCaja = this.state.listaCaja ? this.state.listaCaja : [];
            formValues.listaEmpleado = this.state.listaEmpleado ? this.state.listaEmpleado : [];
            formValues.fechaReferencial = response.fechaReferencial;
            formValues.serie = response.nroSerie;
            formValues.idEstablecimiento = response.iD_Establecimiento;
            formValues.idResponsable = response.iD_Empleado;
            formValues.idCaja = response.iD_Caja;
            formValues.responsable = response.empleado;
            formValues.usuario = response.nroEmpleado;

            formValues.saldoSoles = response.saldoInicialSoles;
            formValues.saldoDolares = response.saldoInicialDolares;


            formValues.correlativo = response.correlativo;

            this.setState({ viewVisible: true, formValues });


        }
    }


    handleDeleteActive = (values) => {
        dialog.confirm("Desea anular la apertura de caja " + values.nroSerie_correlativo + "?", async () => {
            var response;

            response = await cajaAperturaService.eliminar(values);


            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleActive = (values) => {
        dialog.confirm("Desea Activar la apertura de caja " + values.nroSerie_correlativo + "?", async () => {
            var response;

            response = await cajaAperturaService.activar(values);


            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleDownloadPdf = async () => {

        var response = undefined;
        var file = undefined;

        /*    if (this.state.imprimirFormValues.idFormato === 1) {
               response = await comprobanteService.pdfA4({ id: this.state.selectedItem.id });
               file = window.URL.createObjectURL(response.data);
           }
   
           if (this.state.imprimirFormValues.idFormato === 2) {
               response = await comprobanteService.ticket({ id: this.state.selectedItem.id });
               file = window.URL.createObjectURL(response.data);
           }
   
           if (this.state.imprimirFormValues.idFormato === 3) {
               response = await comprobanteService.ticket50({ id: this.state.selectedItem.id });
               file = window.URL.createObjectURL(response.data);
           }
   
           if (response !== undefined)
               global.dowloadFile(response.data, this.state.selectedItem.serieDocumentoComprobante + ".pdf");
        */
        global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.selectedItem.nroSerie_correlativo + ".pdf");
    };



    handleAnexo = async (item) => {

        debugger
        var response = item;
        var param = this.state.filter;
        param.id = item.id;
        param.page = 1;

        var response_anexo = await arqueoCajaService.obtenerAnexoId(param);


        if (response !== undefined) {


            var formValues = this.fetchEmptyFormValues();
            formValues.id = response.id;
            formValues.TipoCambio = response.tipoCambio;
            formValues.FechaTipoCambio = response.fecha;
            formValues.serie = response.nroSerie;
            formValues.establecimiento = response.establecimiento;
            formValues.empleado = response.empleado;
            formValues.caja = response.caja;
            formValues.responsable = response.empleado;
            formValues.usuario = response.nroEmpleado;
            formValues.idCajaEstado = response.idCajaEstado;
            formValues.fechaApertura = response.fecha + '-' + response.hora;
            formValues.fechaCierre = response.fechaCierre + '-' + response.horaCierre;
            formValues.correlativo = response.correlativo;
            formValues.listaAnexo = response_anexo ? response_anexo : [];

        }

        this.setState({
            viewAnexo: true,
            formValues

        });
    };

    handleExportExcelAnexo = async () => {
        this.setState({ loadingExcel: true });
        debugger
        var response = this.state.formValues;
        var data = new Object();
        data.id = response.id;
        data.nroSerie = response.serie;
        data.correlativo = response.correlativo;

        data.establecimiento = response.establecimiento;
        data.empleado = response.empleado;
        data.caja = response.caja;
        data.tipoCambio = response.TipoCambio;
        data.fechaApertura = response.fechaApertura;
        data.fechaCierre = response.fechaCierre;

        switch (response.idCajaEstado) {
            case 1: //registado
                data.estado = "REGISTRADO";
                break;
            case 2://ANULADA
                data.estado = "ANULADA";
                break;
            case 3://APERTURADA
                data.estado = "APERTURADA";
                break;
            case 4://CERRADO
                data.estado = "CERRADO";
                break;
            case 5://POR CERRAR
                data.estado = "POR CERRAR";
                break;
            default:
                data.estado = "";

        }
        var response = await arqueoCajaService.excelAnexo(data);

        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Anexo.xlsx");
    }



    /* handleViewCierre = async (item) => {
    
        var response = await cajaAperturaService.obtenerPorId(item.id);
        var response_resumen = await cajaAperturaService.obtenerResumenId(item.id);
    
        if (response !== undefined) {
    
    
            var formValues = this.fetchEmptyFormValues();
            formValues.listaEstablecimiento = this.state.listaEstablecimiento ? this.state.listaEstablecimiento : [];
            formValues.TipoCambio = response.tipoCambio;
            formValues.FechaTipoCambio = response.fecha;
            formValues.listaCaja=this.state.listaCaja ? this.state.listaCaja : [];
            formValues.listaEmpleado=this.state.listaEmpleado ? this.state.listaEmpleado : [];
            formValues.id=item.id;
            formValues.serie=response.nroSerie;
            formValues.idEstablecimiento=response.iD_Establecimiento;
            formValues.idResponsable=response.iD_Empleado;
            formValues.idCaja=response.iD_Caja;
            formValues.responsable=response.empleado;
            formValues.usuario=response.nroEmpleado;
    
            formValues.saldoSoles=response.saldoInicialSoles;
            formValues.saldoDolares=response.saldoInicialDolares;
            formValues.listaResumen=response_resumen? response_resumen:[];
    
            formValues.correlativo=response.correlativo;
    
            formValues.listaEfectivoSoles=this.state.listaEfectivoSoles;
            formValues.listaEfectivoDolares=this.state.listaEfectivoDolares ;
    
            this.setState({ viewCierreVisible:true, formValues }); 
    
    
        }
    } */

    handleViewCierre = (values) => {

        dialog.confirm("Desea cerrar la apertura de caja " + values.nroSerie_correlativo + "?", async () => {
            var response;

            response = await cajaAperturaService.cerrar_arqueo(values);


            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };



    //#endregion END VIEW




    //#region LOAD  SERVICE OR CALL SERVICE

    async componentDidMount() {
        var idUsuario = auth.user().id;
        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: TESORERIA });
        var flagTS = configuraciones.filter((m) => m.abreviatura === VER_CAJA_COB).length >= 1 ? true : false;

        const idEmpleado = flagTS ? 0 : auth.user().id;

        this._initPagination({ ...this.state.filter, idEmpleado }, cajaAperturaService.paginacion);

        const establecimientos = await establecimientoService.principales();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const cajas = await cajaService.listar();
        const empleados = await vendedorService.listar();
        const seriecorrelativo = await cajaAperturaService.Getcorrelativo();
        const efectivos = await cajaAperturaService.Getefectivo();
        const permisosUsuario = await usuarioService.usarioEstablecimiento(auth.user().id, 1)

        const soles = efectivos.filter(m => m.id_Moneda === SOLES);
        const dolares = efectivos.filter(m => m.id_Moneda === DOLARES_AMERICANOS);

        const estado = await cajaService.listarEstado();
        this.setState({
            loadingSource: false,
            listaEstablecimiento: establecimientos ? establecimientos : [],
            listaCaja: cajas ? cajas : [],
            listaEstado: estado ? estado : [],
            serie_correlativo: seriecorrelativo ? seriecorrelativo : {},
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            listaEmpleado: empleados ? empleados : [],
            listaEfectivoSoles: soles ? soles : [],
            listaEfectivoDolares: dolares ? dolares : [],
            permisosUsuario: permisosUsuario ? permisosUsuario : [],
            configuraciones: configuraciones ? configuraciones : [],
            filter: {
                ...this.state.filter,
                idEmpleado: idEmpleado
            }

        });

    }

    //#endregion END  LOAD  SERVICE OR CALL SERVICE


    render() {
        return (
            <div>

                <Header
                    title="Apertura y Cierre de Caja"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.listaEstablecimiento}
                    cajas={this.state.listaCaja}
                    empleados={this.state.listaEmpleado}
                    estados={this.state.listaEstado}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    loadingImprimir={this.state.loadingImprimir}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onView={this.handleView}
                    onEdit={this.handleEdit}
                    onChange={this._handleChangePagination}
                    onDeleteActive={this.handleDeleteActive}
                    onActive={this.handleActive}
                    onAnexo={this.handleAnexo}
                    onViewCierre={this.handleViewCierre}
                    onImprimir={this.handleImprimir}

                />

                <FormModal
                    visible={this.state.visible}
                    loadingChange={this.state.loadingChange}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onFilter={this.handleFilter}
                    onSave={this.handleSave}
                    onChange={this.handleChangeEstablecimiento}
                    onChangeAutocomplete={this.handleChangeAutocomplete}
                    onClearAutocomplete={this.handleClearAutocomplete}


                />

                <ViewModal
                    visible={this.state.viewVisible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ viewVisible: false })}
                //onSave={this.handleSave}
                />


                <CierreModal
                    visible={this.state.viewCierreVisible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ viewCierreVisible: false })}
                    onSave={this.handleCerrarCaja}
                />

                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />


                <AnexoModal
                    visible={this.state.viewAnexo}
                    formValues={this.state.formValues}
                    pagination={this.state.formValues.listaAnexo}
                    onClose={() => this.setState({ viewAnexo: false })}
                    onExportExcel={this.handleExportExcelAnexo}

                />
            </div>
        )
    }

}